import DocTypeConfig from "../../models/config/DocTypeConfig";
import "../../styles/classification/modelTypeEnabledDocType.css";
import { TemplateType } from "../../types/TemplateType";
import { ModelStatus } from "../../types/ModelStatus";
import { AdvancedTooltip } from "../tooltips/AdvancedTooltip";
import {
  TTTemplateEnabled,
  TTTemplateType,
  TTDocumentType,
} from "../tooltips/ConfigurationTooltips";
import { DocTypeConfigSelector } from "./DocTypeConfigSelector";
import { TemplateTypeSelector } from "./TemplateTypeSelector";
import { ModelStatusSelector } from "./ModelStatusSelector";
import { InheritTransformRules } from "../tooltips/classification/ModelTypeEnabledDocTypeTooltips";

export { ModelTypeEnabledDocType };

type Props = {
  forceValidate: boolean;
  enabled: boolean;
  docType: string;
  templateType: TemplateType;
  status: ModelStatus;
  inheritTransformRules: boolean;
  docTypes: DocTypeConfig[];
  onForceValidate: (forceValidate: boolean) => void;
  onEnabled: (enabled: boolean) => void;
  onDocType: (doctype: DocTypeConfig) => void;
  onTemplateType: (templateType: TemplateType) => void;
  onStatus: (status: ModelStatus) => void;
  onInheritTransformRules: (inheritTransformRules: boolean) => void;
};

const ModelTypeEnabledDocType = (props: Props) => {
  return (
    <div className={"modelTypeEnabledDocType"}>
      <div className={"generalModel"}>
        <AdvancedTooltip tooltipText={TTTemplateType}>
          {(tProps) => <span {...tProps}>Template Type: </span>}
        </AdvancedTooltip>
        <TemplateTypeSelector
          selected={props.templateType}
          onChange={props.onTemplateType}
        />
      </div>
      <div className={"generalModel"}>
        <span>Model Status: </span>
        <ModelStatusSelector
          selected={props.status}
          onChange={props.onStatus}
        />
      </div>
      {/* </div> */}
      {/* <div className={'row'}> */}
      <div className={"docTypeConfig"}>
        <AdvancedTooltip tooltipText={TTDocumentType}>
          {(tProps) => <span {...tProps}>Document Type: </span>}
        </AdvancedTooltip>
        <DocTypeConfigSelector
          docTypeConfigs={props.docTypes}
          selected={props.docType}
          onChange={props.onDocType}
        />
      </div>
      <div className={"enabledModel"}>
        <AdvancedTooltip tooltipText={TTTemplateEnabled}>
          {(tProps) => (
            <label {...tProps}>
              Template Enabled:
              <input
                type={"checkbox"}
                checked={props.enabled}
                onChange={(e) => props.onEnabled(e.target.checked)}
              />
            </label>
          )}
        </AdvancedTooltip>
      </div>
      <div className={"forceValidate"}>
        {/* <AdvancedTooltip tooltipText={TTTemplateEnabled}>
                    {tProps =>( */}
        <label>
          {/* {...tProps}>*/}
          Force Review:
          <input
            type={"checkbox"}
            checked={props.forceValidate}
            onChange={(e) => props.onForceValidate(e.target.checked)}
          />
        </label>
        {/* )}</AdvancedTooltip> */}
      </div>
      <div className={"enabledModel"}>
        <AdvancedTooltip tooltipText={InheritTransformRules}>
          {(tProps) => (
            <label {...tProps}>
              Inherit Transform Rules:
              <input
                type={"checkbox"}
                checked={props.inheritTransformRules}
                onChange={(e) =>
                  props.onInheritTransformRules(e.target.checked)
                }
              />
            </label>
          )}
        </AdvancedTooltip>
      </div>
    </div>
  );
};
